import { render } from "./SelectStages.vue?vue&type=template&id=46473ee5&scoped=true"
import script from "./SelectStages.vue?vue&type=script&lang=js"
export * from "./SelectStages.vue?vue&type=script&lang=js"

import "./SelectStages.vue?vue&type=style&index=0&id=46473ee5&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46473ee5"]])

export default __exports__